import { render, staticRenderFns } from "./NewAllocationUnitDialog.vue?vue&type=template&id=c336772e&"
import script from "./NewAllocationUnitDialog.vue?vue&type=script&lang=js&"
export * from "./NewAllocationUnitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports